import { makeEnum } from '@transcend-io/type-utils';

/**
 * Status of UI variants
 */
export const UiVariantStatus = makeEnum({
  /** The UI variant is not used - not deployed or saved */
  Draft: 'DRAFT',
  /** The UI variant is active - saved but not deployed */
  Active: 'ACTIVE',
  /** The UI variant is published - has been deployed */
  Published: 'PUBLISHED',
});

/** Override type */
export type UiVariantStatus =
  (typeof UiVariantStatus)[keyof typeof UiVariantStatus];
